import { render } from "./rbqm_table.vue?vue&type=template&id=2373fa12&scoped=true"
import script from "./rbqm_table.vue?vue&type=script&lang=js"
export * from "./rbqm_table.vue?vue&type=script&lang=js"

import "./rbqm_table.vue?vue&type=style&index=0&id=2373fa12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2373fa12"]])

export default __exports__